export enum EmailEvent {
  Click = 'click',
  Delivered = 'delivered',
  Open = 'open',
}
